import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [quantity, setQuantity] = useState(1);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  useEffect(() => {
    setSelectedImageIndex(0);
  }, [product?.id]);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail main">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const increaseQuantity = () => setQuantity((prev) => prev + 1);
  const decreaseQuantity = () =>
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));

  const productImages =
    product.images && product.images.length > 0
      ? product.images
      : [product.detailImage];

  return (
    <div className="product-detail main">
      <div className="product-detail-container">
        <div className="breadcrumb-nav">
          <div className="breadcrumb-left">
            <Link to="/" className="breadcrumb-link">
              HOME
            </Link>{" "}
            /{" "}
            <Link to="/shop" className="breadcrumb-link">
              NEW ARRIVALS
            </Link>{" "}
            /{" "}
            <span className="breadcrumb-current">
              {product.name.toUpperCase()}
            </span>
          </div>
        </div>

        <div className="product-content">
          <div className="product-image-section">
            <div className="main-image-frame">
              <img
                src={productImages[selectedImageIndex]}
                alt={`${product.name} - view ${selectedImageIndex + 1}`}
                className="main-image"
              />
            </div>

            {productImages.length > 1 && (
              <div className="product-thumbnails" aria-label="Product images">
                {productImages.map((image, index) => (
                  <button
                    type="button"
                    key={image}
                    className={`thumbnail-btn ${
                      selectedImageIndex === index ? "selected" : ""
                    }`}
                    onClick={() => setSelectedImageIndex(index)}
                    aria-label={`Show ${product.name} view ${index + 1}`}
                    aria-pressed={selectedImageIndex === index}
                  >
                    <img src={image} alt="" />
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="product-info-section">
            <span className="product-badge">NEW</span>
            <h1 className="product-title">{product.name.toUpperCase()}</h1>
            <p className="product-price">${product.price}</p>

            {product.colors && product.colors.length > 0 && (
              <div className="options-section">
                <label className="option-label">
                  Color: <span>{selectedColor}</span>
                </label>
                <div className="options-container">
                  {product.colors.map((color, index) => (
                    <button
                      key={index}
                      className={`option-btn ${
                        selectedColor === color ? "selected" : ""
                      }`}
                      onClick={() => setSelectedColor(color)}
                    >
                      {color}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {product.size && product.size.length > 0 && (
              <div className="options-section">
                <label className="option-label">
                  Size: <span>{selectedSize}</span>
                </label>
                <div className="options-container">
                  {product.size.map((size, index) => (
                    <button
                      key={index}
                      className={`option-btn ${
                        selectedSize === size ? "selected" : ""
                      }`}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div className="quantity-section">
              <label className="qty-label">Qty</label>
              <div className="add-to-cart-row">
                <div className="quantity-selector">
                  <button onClick={decreaseQuantity} className="qty-btn">
                    &minus;
                  </button>
                  <input
                    type="text"
                    value={quantity}
                    readOnly
                    className="qty-input"
                  />
                  <button onClick={increaseQuantity} className="qty-btn">
                    +
                  </button>
                </div>
                <button onClick={handleAddToCart} className="add-to-cart-btn">
                  ADD TO CART
                </button>
              </div>
            </div>

            <div className="pickup-info">
              <div className="pickup-status">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  stroke="#38c9c6"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="check-icon"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span>
                  Online dispatch available from <strong>Hong Kong</strong>
                </span>
              </div>
              <p className="pickup-ready">
                Usually dispatched in 1–3 business days
              </p>
            </div>

            <div className="product-description">
              {product.description.map((desc, index) => (
                <p key={index}>{desc}</p>
              ))}

              {product.Features && product.Features.length > 0 && (
                <>
                  <h2 className="product-section-title">PRODUCT DETAILS</h2>
                  <ul className="product-features">
                    {product.Features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </>
              )}

              <dl className="product-specifications">
                <div className="specification-row">
                  <dt>Material</dt>
                  <dd>{product.material}</dd>
                </div>
                <div className="specification-row">
                  <dt>{product.detailLabel}</dt>
                  <dd>{product.detailValue}</dd>
                </div>
                <div className="specification-row">
                  <dt>Care</dt>
                  <dd>{product.care}</dd>
                </div>
                <div className="specification-row">
                  <dt>Product code</dt>
                  <dd>{product.productCode}</dd>
                </div>
                <div className="specification-row">
                  <dt>Sold by</dt>
                  <dd>{product.seller}</dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
